import base from "../../base";
import userIsAdmin from "../Shared/functions/userIsAdmin";

export default async function verifyBasicUser(uid, userToBasicify) {
	if (!(await userIsAdmin(uid))) return;

	base.post(`users/${userToBasicify}/verified/`, { data: true });
	base.post(`basicUsers/${userToBasicify}`, { data: true });
}
